import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  Search, UpdateURLParams, getSearchResults,
  MenuItem, getMenus, GetMenuOption, GetAllSearchQueries,
  SearchProblem, SearchResultsPayload, ApplicationAction, getScrollToResults,
  ScrollToResults, GoToProblemDetails, getAppView, SetAppView, MenuDictionaries,
  getDictionaries, SaveSearchQueryPayload, SaveSearchQuery,
  getSavedSearchQueries, SearchQuery, RemoveSavedSearchQuery, getProblems, getLinkedCases, LinkedCase, LinkedCaseProblems,
  LinkedCasePayload, AddProblemLinkedCases, getMapState, GetProblems, SetNoMapLocation, DelayedAction, GetSearchListLinkedCases, GetAllProblemLinkedCases, BatchExportProgress, CloseProblem,
  getNoPin,
  SearchProblemParsed
} from 'src/app/state-management';
import { Observable, Subject, Subscription } from 'rxjs';
import { delay, filter, takeUntil } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DatePipe } from '@angular/common';
import {
  DnvMapAction, CenterMap, DnvMapState, SetZoom, SetMarkers, EditShapes,
  SetMapFeatureLayers, StartDraw, SetShowDrawControl, SetMapClusterView, SetMapShowFindMe, PlainMapFunctionsOnly, DnvMarker, DnvLatLng
} from 'dnv-lib';
import { Problem } from 'src/app/models/problem';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { BatchExportComponent } from '../batch-export/batch-export.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  standalone: false
})
export class SearchComponent implements OnInit {
  @ViewChild('linkProblemsModal') linkProblemsModal: TemplateRef<any>;
  @ViewChild('deleteSavedSearchModal') deleteSavedSearchModal: TemplateRef<any>;
  @ViewChild('summarizeCasesModal') summarizeCasesModal: TemplateRef<any>;
  @ViewChild('closeCasesModal') closeCasesModal: TemplateRef<any>;

  mapState$: Observable<DnvMapState>;
  searchResults$: Observable<SearchProblem[]>;
  menuOption$: Observable<MenuItem>;
  menuDictionaries$: Observable<MenuDictionaries>;
  scrollToResults$: Observable<boolean>;
  savedSearchQueries$: Observable<SearchQuery[]>;
  problems$: Observable<Problem[]>;
  linkedCases$: Observable<LinkedCase[]>;
  appView$: Observable<string>;
  showSpinner = false;
  noResults = false;
  private ngUnsubscribe: Subject<void> = new Subject();
  queryParams: Params = null;
  searchQueryParams: Params = null;
  mapState: DnvMapState;
  queryToDelete: SearchQuery;

  // Problem Linking variables
  modal: NgbModalRef = null;
  problemsToLink: SearchProblem[] = [];
  linkStatusHighestLevel = '';
  linkedCases: LinkedCase[] = [];
  parentCases: LinkedCaseProblems[] = [];
  childCases: LinkedCaseProblems[] = [];
  existingCases: LinkedCaseProblems[] = [];
  menuDictionaries: MenuDictionaries;
  linkNotesText = '';
  assignParentsToggled = true;
  linkedCaseExists = false;
  forceLinkOnly = false;

  clearSearchFormEvent = 'clearSearchFormEvent';
  closeProblemForm: UntypedFormGroup;

  routeSubscription: Subscription = new Subscription();
  closeCaseResolution: string;
  problemNo: string;
  problemDetail: Problem;
  problemLatLng: DnvLatLng;
  hasSummarizeError = false;
  problemsToSummarize: SearchProblem[] = [];
  problemsToClose: SearchProblem[] = [];
  problemsAlreadyClosed: SearchProblem[] = [];
  isSummarizing: boolean = false;
  exportPanelTitle: string = "";
  caseRendering: number = 0;
  currentSummaryStep: string = "";
  noPin$: Observable<boolean>;

  constructor(
    private store: Store<{}>,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private deviceService: DeviceDetectorService
  ) {
    this.mapState$ = this.store.select(getMapState);
    this.searchResults$ = this.store.select(getSearchResults);
    this.menuOption$ = this.store.select(getMenus);
    this.menuDictionaries$ = this.store.select(getDictionaries);
    this.scrollToResults$ = this.store.select(getScrollToResults);
    this.appView$ = this.store.select(getAppView);
    this.savedSearchQueries$ = this.store.select(getSavedSearchQueries);
    this.linkedCases$ = this.store.select(getLinkedCases);
    this.problems$ = this.store.select(getProblems);
    this.noPin$ = this.store.select(getNoPin);
  }

  ngOnInit() {
    // this.store.dispatch(new GetAllProblemLinkedCases());
    this.store.dispatch(new SetMapClusterView(true));
    this.store.dispatch(new SetMapShowFindMe(false));
    this.store.dispatch(new PlainMapFunctionsOnly(true));
    this.store.dispatch(new SetMarkers([]));
    this.store.dispatch(new SetMapFeatureLayers([]));

    // Make Draw Control show up
    this.store.dispatch(new SetShowDrawControl(true));
    this.store.dispatch(new GetMenuOption());
    this.store.dispatch(new GetAllSearchQueries());

    if (this.route.snapshot.queryParams) {
      this.queryParams = this.route.snapshot.queryParams;
    }

    // tslint:disable-next-line: ngrx-avoid-dispatching-multiple-actions-sequentially
    this.routeSubscription = this.route.queryParams
      .pipe(filter((params: any) => params.ProblemNo))
      .subscribe((params: any) => {
        if (params.ProblemNo && params.ProblemNo.length > 0) {
          this.problemNo = params.ProblemNo;
          this.store.dispatch(new GetProblems({ problemNo: this.problemNo }));
        }
      });

    this.searchResults$
      .pipe(takeUntil(this.ngUnsubscribe),
      ).subscribe(results => {
        if (this.showSpinner) {
          this.showSpinner = !this.showSpinner;
          // a search occured and no results came back
          if (results.length === 0) {
            this.noResults = true;
          }

          // else {
          //   const caseNumbers: string[] = [];
          //   results.forEach(p => caseNumbers.push(p.caseNumber));
          //   this.store.dispatch(new GetSearchListLinkedCases(caseNumbers));
          // }
        }
      });

    this.linkedCases$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(linkedCases => this.linkedCases = linkedCases);
    this.mapState$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((results: DnvMapState) => this.mapState = results);
    this.menuDictionaries$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (dictionary: MenuDictionaries) => this.menuDictionaries = dictionary
    );

    // detect device type
    if (this.deviceService.isDesktop()) {
      this.store.dispatch(new SetAppView('desktop'));
    } else if (this.deviceService.isTablet()) {
      this.store.dispatch(new SetAppView('tablet'));
    } else if (this.deviceService.isMobile()) {
      this.store.dispatch(new SetAppView('mobile'));
    }

    this.setAreaSearchPin();

    this.closeProblemForm = new UntypedFormGroup({
      resolution: new UntypedFormControl('', [Validators.required])
    });
  }

  handleQuerySelect(searchQuery: SearchResultsPayload) {
    const clearSearchFormEvt = new CustomEvent(this.clearSearchFormEvent);
    document.dispatchEvent(clearSearchFormEvt);

    this.searchQueryParams = searchQuery;
  }


  openDeleteQueryPrompt(searchQuery: SearchQuery) {
    this.queryToDelete = searchQuery;
    this.openModal(this.deleteSavedSearchModal);
  }

  closeDeleteQuery() {
    this.closeModal();
    this.queryToDelete = null;
  }

  doSavedQueryDelete() {
    this.store.dispatch(new RemoveSavedSearchQuery(this.queryToDelete));
    this.closeDeleteQuery();
  }

  doSearch(searchQuery: SearchResultsPayload) {
    this.closeAndResetLinkProblemsPrompt();

    this.noResults = false;
    this.store.dispatch(new Search(searchQuery));
    this.store.dispatch(new UpdateURLParams(searchQuery));
    this.store.dispatch(new ScrollToResults(false));
    this.showSpinner = true;
    setTimeout(function () {
      document.querySelector('#searchResults')
        .scrollIntoView(true);
    }, 100);

  }

  clearResults(action: ApplicationAction) {
    this.closeAndResetLinkProblemsPrompt();

    this.store.dispatch(action);
    this.store.dispatch(new SetMarkers([]));
    this.noResults = false;
    this.store.dispatch(new ScrollToResults(false));
    this.router.navigateByUrl('/search');
  }

  saveSearchQuery(searchQuery: SaveSearchQueryPayload) {
    this.store.dispatch(new SaveSearchQuery(searchQuery));
  }

  onProblemNumEmit(problemNo: string) {
    this.closeAndResetLinkProblemsPrompt();
    this.store.dispatch(new GoToProblemDetails({ problemNo: problemNo, activityNo: '' }));
  }

  onSaveFile(results: string[]) {
    // tslint:disable-next-line: max-line-length
    const header = 'sep=|\r\nCase Number| Group| Problem Type| Location| Source| Status| Assignee| Description| Submit Date| Complete Date| Reporter\r\n';

    let csvData = '';
    results.forEach(s => {
      csvData = csvData + s + '\r\n';
    });

    const blob = new Blob([header + csvData], { type: 'text/csv' });
    const pipe = new DatePipe('en-CA');
    const dateStr = pipe.transform(new Date(), 'yyyyMMddhhmmss');
    saveAs(blob, 'search-export-' + dateStr + '.csv');
  }

  convertCaseNoToURL(problemNo: string): string {
    const webRoot = `https://${window.location.host}`;
    const problemURL = `${webRoot}/problemdetails?ProblemNo=${problemNo}`;
    return problemURL;
  }

  getProblemType(id: number): String {
    return this.menuDictionaries.problemTypes.get(id)?.problemType_Name;
  }

  handleAssignRadioClick(event: any) {
    if (event.target.checked) {
      if (event.target.value === '1') {
        this.assignParentsToggled = true;
      } else {
        this.assignParentsToggled = false;
      }
    }
  }

  showTooltip() {
    (document.getElementsByClassName('tooltipText') as any)[0].style.visibility = 'visible';
    (document.getElementsByClassName('tooltipArrow') as any)[0].style.visibility = 'visible';
  }

  hideToolTip() {
    (document.getElementsByClassName('tooltipText') as any)[0].style.visibility = 'hidden';
    (document.getElementsByClassName('tooltipArrow') as any)[0].style.visibility = 'hidden';
  }

  getLinkedCaseStatus(linkedCase: LinkedCase, problem: Problem) {
    if (linkedCase) {
      if (!linkedCase.isRelated) {
        return 'Related';
      }
    }

    return problem.linkedStatus;
  }

  openModal(modal: TemplateRef<any>) {
    this.modal = this.modalService.open(modal, { backdrop: 'static' });
  }

  closeModal() {
    if (this.modal) {
      this.modal.close();
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(evt: KeyboardEvent) {
    if (this.modal) {
      this.closeLinkProblemPrompt();
    }
  }

  openSummarizeCasesPrompt(problems: SearchProblemParsed[]) {
    this.problemsToSummarize = problems as unknown as SearchProblem[];
    this.openModal(this.summarizeCasesModal);
  }

  openCloseCasesPrompt(problems: SearchProblemParsed[]) {
    this.problemsToClose =  problems as unknown as SearchProblem[];

    this.problemsAlreadyClosed = this.problemsToClose.filter(p => { if (p.status === 'Closed') return p; }); //3 = closed

    this.openModal(this.closeCasesModal);
  }

  closeSummaryModal() {
    this.closeModal();
    this.problemsToSummarize = [];
  }

  getProblemCountDetails() {
    if (this.currentSummaryStep !== 'Summarizing problems' && this.currentSummaryStep !== 'Exporting PDF') {
      return `Rendering problem: ${this.caseRendering} / ${this.problemsToSummarize.length}`;
    } else {
      return `Rendered problems: ${this.caseRendering} / ${this.problemsToSummarize.length}`;
    }
  }

  onSummarizeCases() {
    const ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      windowClass: 'case-summary-modal'
    };

    let includingHistory = (document.getElementById("radio_addHistory") as any).checked;
    let ignoringHistory = (document.getElementById("radio_ignoreHistory") as any).checked;
    this.hasSummarizeError = !includingHistory && !ignoringHistory;

    if (!this.hasSummarizeError) {
      this.closeModal();

      document.addEventListener('exportPanelUpdate', (event: CustomEvent) => {
        let data = event.detail;
        let status = data.status;
        let problemNo = data.currentProblem;

        if (status === BatchExportProgress.LoadingDetails || status === BatchExportProgress.LoadingHistory) {
          this.exportPanelTitle = `Preparing ${problemNo}`;
          this.currentSummaryStep = status === BatchExportProgress.LoadingDetails ?
            'Rendering problem details' : 'Rendering problem history';

        } else if (status === BatchExportProgress.Summarizing) {
          this.exportPanelTitle = `Building Summary`;
          this.currentSummaryStep = 'Summarizing problems';

        } else {
          this.exportPanelTitle = 'Summary complete';
          this.currentSummaryStep = 'Exporting PDF';
        }

        this.caseRendering = data.problemLoading;
        this.isSummarizing = true;
      });

      let modalRef = this.modalService.open(BatchExportComponent, ngbModalOptions);
      modalRef.componentInstance.batchExportProblems = this.problemsToSummarize
        .map(problem => problem.caseNumber)
        .sort()
        .reverse();

      modalRef.componentInstance.includeHistory = includingHistory;

      modalRef.result.then(() => {
        this.isSummarizing = false;
        this.exportPanelTitle = "";
        this.currentSummaryStep = "";

        this.waitForModalClosed(".case-summary-modal");
        document.removeAllListeners('exportPanelUpdate');
      });
    }
  }

  onCloseCases() {
    this.store.dispatch(new CloseProblem({ problemId: this.problemsToClose.map(p => p.problemId), resolution: this.closeCaseResolution }));
    this.closeAndResetLinkProblemsPrompt();
  }

  async waitForModalClosed(className: string) {
    // await new Promise(resolve => {
    //   let interval = setInterval(() => {
    //     let oldModalPresent = Array.from(document.querySelectorAll(className)).length > 0;
    //     if (!oldModalPresent) {
    //       clearInterval(interval);
    //       resolve('removed');
    //     }
    //   }, 10);
    // });

    let removeChilds = async (node: HTMLElement) => {
      var last;
      while (last = node.lastChild) node.removeChild(last);
    };

    if (document.querySelector(className)) {
      await removeChilds(document.querySelector(className));
    }
  }

  onLinkProblems(problems: SearchProblemParsed[]) {
    this.problemsToLink = problems as unknown as SearchProblem[];
    this.linkStatusHighestLevel = 'Unlinked';

    // Determine whether a linked case exists between selected members
    this.problemsToLink.forEach(problem => {
      const linkedCaseEntry = this.linkedCases.filter(linkedCase =>
        linkedCase.problemOneNumber === problem.caseNumber ||
        linkedCase.problemTwoNumber === problem.caseNumber);

      this.problemsToLink.forEach(prbCompare => {
        linkedCaseEntry.forEach(linkedCase => {
          const linkExists = (
            (linkedCase.problemOneNumber === problem.caseNumber && linkedCase.problemTwoNumber === prbCompare.caseNumber) ||
            (linkedCase.problemOneNumber === prbCompare.caseNumber && linkedCase.problemTwoNumber === problem.caseNumber)
          );

          if (linkExists) {
            this.linkedCaseExists = true;
            const indexCase = this.existingCases.findIndex(entry => entry.problemOne.problemNo === linkedCase.problemOneNumber);

            if (indexCase !== -1) {
              const caseProbTwoExists = this.existingCases[indexCase].problemTwoArr.some(
                problemCase => problemCase.problemNo === linkedCase.problemTwoNumber
              );

              if (!caseProbTwoExists) {
                this.existingCases[indexCase].problemTwoArr.push(linkedCase.problemTwo);
              }
            } else {
              this.existingCases.push({
                problemOne: linkedCase.problemOne,
                problemTwoArr: [linkedCase.problemTwo],
                linkedCase: linkedCase
              });
            }
          }
        });
      });
    });

    // Determine the highest linkedCase status
    if (!this.linkedCaseExists) {
      this.problemsToLink.forEach(problem => {
        const parentLinkedEntries = this.linkedCases.filter(
          linkedCase => linkedCase.problemOneNumber === problem.caseNumber && linkedCase.isRelated
        );
        const childLinkedEntry = this.linkedCases.find(
          linkedCase => linkedCase.problemTwoNumber === problem.caseNumber && linkedCase.isRelated
        );

        if (parentLinkedEntries.length) {
          parentLinkedEntries.forEach(entry => {

            // handle the parent entries
            if (entry.problemOneNumber === problem.caseNumber && entry.problemOne.linkedStatus === 'Parent') {
              this.linkStatusHighestLevel = 'Parent';
              const parentCaseIndex = this.parentCases.findIndex(
                parentCase => parentCase.problemOne.problemNo === entry.problemOne.problemNo
              );

              // No parent case exists yet
              if (parentCaseIndex === -1) {
                this.parentCases.push({
                  problemOne: entry.problemOne,
                  problemTwoArr: entry.problemTwo_RefId ? [entry.problemTwo] : []
                });
              } else {
                if (entry.problemTwo_RefId) {
                  this.parentCases[parentCaseIndex].problemTwoArr.push(entry.problemTwo);
                }
              }
            }
          });
        }

        if (!!childLinkedEntry) {
          this.linkStatusHighestLevel = this.linkStatusHighestLevel === 'Unlinked' ? 'Child' : this.linkStatusHighestLevel;
          const parentProblemLinkedCases = this.linkedCases.filter(
            linkedCase => linkedCase.problemOneNumber === childLinkedEntry.problemOneNumber && linkedCase.isRelated
          );

          // handle child problems
          parentProblemLinkedCases.forEach(entry => {
            const childCasesParentIndex = this.childCases.findIndex(
              childCase => childCase.problemOne.problemNo === entry.problemOne.problemNo
            );

            if (childCasesParentIndex >= 0) {
              const childExists = this.childCases[childCasesParentIndex].problemTwoArr.some(
                childCase => childCase.problemNo === entry.problemTwoNumber
              );

              if (!childExists) {
                this.childCases[childCasesParentIndex].problemTwoArr.push(entry.problemTwo);
                this.forceLinkOnly = true;
              }
            } else {
              this.childCases.push({
                problemOne: entry.problemOne,
                problemTwoArr: entry.problemTwo_RefId ? [entry.problemTwo] : []
              });
            }
          });

          // insert into parentCases to handle case when both parents and children
          // are selected so we need to display for multiple parent scenario
          const parentCaseExists = this.parentCases.some(
            parentCase => parentCase.problemOne.problemNo === childLinkedEntry.problemOne.problemNo
          );

          if (!parentCaseExists) {
            this.parentCases.push({
              problemOne: childLinkedEntry.problemOne
            });
          }
        }
      });
    }

    this.openModal(this.linkProblemsModal);
  }

  linkProblems() {
    let selectedRelationship = '';
    const newLinkedCases: LinkedCasePayload[] = [];

    // Determine what relationship between the selected problems and problemOne will be like
    switch (this.linkStatusHighestLevel) {
      case 'Unlinked':
        selectedRelationship = this.assignParentsToggled ?
          (<HTMLInputElement>document.querySelector('input[name="linkedCaseSelection"]:checked')).value : 'linkOnly';
        break;

      case 'Child':
        selectedRelationship = this.assignParentsToggled && this.childCases.length === 1 &&
          !(this.childCases.some(childCase => childCase.problemTwoArr.length > 1)) ?
          this.childCases[0].problemOne.problemNo : 'linkOnly';
        break;

      case 'Parent':
        selectedRelationship = this.assignParentsToggled && this.parentCases.length === 1 && this.childCases.length === 0 ?
          this.parentCases[0].problemOne.problemNo : 'linkOnly';
        break;

      default:
        selectedRelationship = 'linkOnly';
    }

    // Case 1: selectedRelationship set to linkOnly
    if (selectedRelationship === 'linkOnly') {

      // Go through each problems and create a link to each of the selected problems
      this.problemsToLink.forEach(problemOne => {
        this.problemsToLink.forEach(problemTwo => {
          if (problemOne.caseNumber !== problemTwo.caseNumber) {
            const linkEntryCreated = newLinkedCases.some(entry => (
              (entry.problemOneNumber === problemOne.caseNumber && entry.problemTwoNumber === problemTwo.caseNumber) ||
              (entry.problemOneNumber === problemTwo.caseNumber && entry.problemTwoNumber === problemOne.caseNumber)
            ));

            if (!linkEntryCreated) {
              newLinkedCases.push({
                application: 'RAP',
                notes: this.linkNotesText,
                isRelated: false,
                problemOneNumber: problemOne.caseNumber,
                problemTwoNumber: problemTwo.caseNumber
              });
            }
          }
        });
      });
    } else {
      // Case 2: selectedRelationship set to the selected problem to be a parent
      const problemOneNumber = selectedRelationship;
      const problemTwoCases = this.problemsToLink.filter(problem => problem.caseNumber !== problemOneNumber);

      problemTwoCases.forEach(problem => {
        newLinkedCases.push({
          application: 'RAP',
          notes: this.linkNotesText,
          isRelated: true,
          problemOneNumber: problemOneNumber,
          problemTwoNumber: problem.caseNumber
        });
      });
    }

    // handle dispatch of linked case event
    this.store.dispatch(new AddProblemLinkedCases(newLinkedCases));
    this.closeAndResetLinkProblemsPrompt();
  }

  closeAndResetLinkProblemsPrompt() {
    this.resetCheckBoxes();
    this.closeLinkProblemPrompt();
  }

  closeLinkProblemPrompt() {
    this.closeModal();

    this.parentCases = [];
    this.childCases = [];
    this.existingCases = [];
    this.linkNotesText = '';
    this.closeCaseResolution = '';
    this.assignParentsToggled = true;
    this.linkedCaseExists = false;
    this.forceLinkOnly = false;
  }

  resetCheckBoxes() {
    const checkBoxElements = document.querySelectorAll('input[type="checkbox"]');
    checkBoxElements.forEach((element: HTMLInputElement) => {
      if (element.checked) {
        element.click();
      }
    });

    setTimeout(() => {
      const cancelLinkProblemBtn: any = document.querySelector('button[title="Cancel Link Problems"]');
      if (cancelLinkProblemBtn !== null) {
        cancelLinkProblemBtn.click();
      }
    }, 250);

    setTimeout(() => {
      const cancelLinkProblemBtn: any = document.querySelector('button[title="Cancel Close Problems"]');
      if (cancelLinkProblemBtn !== null) {
        cancelLinkProblemBtn.click();
      }
    }, 250);

    this.problemsToLink = [];
  }

  onMapUpdate(action: any) {
    if (action.type) {
      this.store.dispatch(action);
    } else if (action.length == 1) {
      this.store.dispatch(action[0]);
    }
    else {
      action.forEach((act: DnvMapAction) => {
        this.store.dispatch(act);
      })
    }

  }


  onMoveChange(state: DnvMapState) {
    this.store.dispatch(new CenterMap({ lat: state.centerPoint.lat, lng: state.centerPoint.lng }));
  }

  onZoomChange(state: DnvMapState) {
    this.store.dispatch(new SetZoom(state.zoomLevel));
  }

  clearDrawing() {
    this.store.dispatch(new StartDraw({ shape: '', guid: '' }));
    this.store.dispatch(new EditShapes([]));

    this.route.queryParams
      .subscribe((params: any) => {
        if (!params.ProblemNo) {
          this.problemDetail = null;
          this.problemNo = null;
        }
      });
  }

  startDrawing() {
    this.store.dispatch(new StartDraw({ shape: 'polygon', guid: '' }));
  }

  setAreaSearchPin() {
    // tslint:disable-next-line: ngrx-avoid-dispatching-multiple-actions-sequentially
    this.problems$
      .pipe(
        delay(200),
        takeUntil(this.ngUnsubscribe),
      ).subscribe(p => {
        this.problemDetail = p[0];
        if (this.problemDetail) {


          if (this.problemDetail.latLng.lat === 0 && this.problemDetail.latLng.lng === 0) {
            this.store.dispatch(new SetNoMapLocation(true));
            this.problemLatLng = { lat: 0, lng: 0 };
          } else {
            this.problemLatLng = { lat: this.problemDetail.latLng.lat, lng: this.problemDetail.latLng.lng };

            const marker: DnvMarker = {
              url: new Date().toISOString(),
              centerPoint: this.problemLatLng,
              popup: '',
              popupOptions: { maxWidth: 400 },
              tooltip: this.problemDetail.problemLocation,
              tooltipOptions: {
                permanent: false,
                direction: 'right',
                offset: [14, -20],
                className: 'map-tooltip'
              },
              clickEvent: true,
              id: this.problemDetail.problemLocation,
              isActive: false,
              activeIcon: {
                iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
                className: 'myDivIconSelected',
                iconSize: [35, 60],
              },
              icon: {
                iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
                className: 'myDivIcon',
                iconSize: [35, 60],
              }
            };

            this.store.dispatch(new SetNoMapLocation(false));
            this.store.dispatch(new SetMarkers([marker]));
            this.store.dispatch(new DelayedAction([
              new CenterMap(this.problemDetail.latLng),
              new SetZoom(Number(5))
            ]));
          }

        }
      });
  }

  setPin() {
    if (this.problemNo) {
      this.setAreaSearchPin();
    }
  }
}
